module.exports = __webpack_public_path__ + "img/lg_ring_y_o_null_1@2x.aacb0d03.png";